import Dialog from "../Dialog";

const DeleteChecklistDialog = ({ checklist, onConfirm }) => {
  const onDelete = async () => {
    if (onConfirm && checklist) {
      await onConfirm(checklist);
    }
  };

  return (
    <Dialog id="modal-checklist-delete">
      <div className="uk-modal-dialog uk-modal-body">
        <button
          className="uk-modal-close-default"
          type="button"
          uk-close="true"
        ></button>
        <h2 className="uk-modal-title">Delete Checklist</h2>
        <p>Are you sure you want to delete "{checklist?.name}"?</p>
        <p className="uk-text-right">
          <button
            className="uk-button hms-btn uk-modal-close uk-modal-delete-cancel"
            type="button"
          >
            Cancel
          </button>
          <button
            className="uk-button hms-btn hms-gray-btn"
            type="button"
            onClick={onDelete}
          >
            Delete
          </button>
        </p>
      </div>
    </Dialog>
  );
};

export default DeleteChecklistDialog;
